// require("@rails/ujs").start()
// require("turbolinks").start()
// require("@rails/activestorage").start()
// require("channels")
// console.log('version+33d');



require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
// require("channels");

import '../styles/application.scss';
import '@fortawesome/fontawesome-free/css/all.css';

import TurbolinksAdapter from "vue-turbolinks"
import Vue from "vue/dist/vue.esm"
import Vuelidate from 'vuelidate'
import setupCSRFToken from "../setupCSRFToken.js"
import VueToast from 'vue-toast-notification'

import 'bootstrap/dist/js/bootstrap.min.js'

import InputForm from 'components/InputForm.vue'
import TextareaForm from 'components/TextareaForm.vue'
import VueTheMask from 'vue-the-mask'

import '@fortawesome/fontawesome-free/js/all.js'

import AdminRecruiterLayout from "layouts/AdminRecruiter.vue"
import AdminLayout from "layouts/Admin.vue"
import LimitedLayout from "layouts/Limited.vue"
import AdminPayment from "layouts/AdminPayment.vue"
import VueCurrencyInput from 'vue-currency-input'
import VueClipboard from 'vue-clipboard2'
import SweetAlertIcons from 'vue-sweetalert-icons'
import VModal from 'vue-js-modal'
import Vue2Filters from 'vue2-filters'
import VueSuggestion from 'vue-suggestion'

import { parseISO } from 'date-fns';
import { formatISO } from 'date-fns';
Vue.use(parseISO, formatISO);

import CKEditor from 'ckeditor4-vue';
import Embed from 'v-video-embed';
// import store from 'store';

Vue.use(CKEditor);
Vue.use(Embed);

import {
  createDateFilter
} from "vue-date-fns";
import locale from "date-fns/locale/pt-BR";

Vue.filter("date", createDateFilter("dd/MM/yyyy HH:mm", {
  locale
}));

import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  faUserSecret
} from '@fortawesome/free-solid-svg-icons'
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

library.add(faUserSecret)

Vue.config.productionTip = false
import {
  InertiaApp,

} from '@inertiajs/inertia-vue'

import {
  Settings
} from 'luxon'

Settings.defaultLocale = 'pt-BR'
const moment = require('moment')
require('moment/locale/pt-br')

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
Vue.use(SweetAlertIcons)
Vue.use(TurbolinksAdapter)
Vue.use(VueSuggestion)
Vue.use(require("vue-moment"), {
  moment
})

Vue.use(Vue2Filters)
Vue.use(VModal, {
  dynamic: true,
  // injectModalsContainer: true,
  dynamicDefaults: {
    clickToClose: true
  }
})
Vue.use(VueToast, {
  position: 'top'
})
Vue.use(Vuelidate)
Vue.use(VueTheMask)
Vue.use(InertiaApp)
// Vue.use(SweetAlertIcons)
Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: {
      prefix: ''
    }
  }
});
setupCSRFToken();
import axiosApi from 'axios';

import { InertiaProgress } from '@inertiajs/progress'

InertiaProgress.init({
  // The delay after which the progress bar will
  // appear during navigation, in milliseconds.
  delay: 250,

  // The color of the progress bar.
  color: '#109bf1',

  // Whether to include the default NProgress styles.
  includeCSS: true,

  // Whether the NProgress spinner will be shown.
  showSpinner: false,
})

Vue.component('inputform', InputForm);
Vue.component('textareaform', TextareaForm);
Vue.component('admin', AdminLayout);
Vue.component('limitedlayout', LimitedLayout);
Vue.component('admin-layout', AdminRecruiterLayout);
Vue.component('admin-payment', AdminPayment);
Vue.component('font-awesome-icon', FontAwesomeIcon);

document.addEventListener("turbolinks:load", () => {

  const app_innertia = document.getElementById('app')

  if (app_innertia) {
    window.eventBus = new Vue()
    window.axios = axiosApi
    // console.log(store);
    new Vue({

      render: h => h(InertiaApp, {
        props: {
          initialPage: JSON.parse(app_innertia.dataset.page),
          resolveComponent: name => {
            if (name) {
              return require(`pages/${name}`).default;
            }
            window.location.reload(true);
          },
        },
      }),
    }).$mount(app_innertia);
  }

});


// 2025-11-17 20:31:57

